import { render, staticRenderFns } from "./PaginationItem.vue?vue&type=template&id=76460511&"
import script from "./PaginationItem.vue?vue&type=script&lang=ts&"
export * from "./PaginationItem.vue?vue&type=script&lang=ts&"
import style0 from "./PaginationItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VPagination } from 'vuetify/lib/components/VPagination';
installComponents(component, {VPagination})
